import { LOCALES } from 'Constants/General';
import ISOStringToDate from './ISOStringToDate';

/**
 * Recibe una fecha raw y la formatea a un formato legible y localizado al usuario.
 * @param {string|undefined|null} date La fecha 'raw' a formatear.
 * @returns {string} Fecha en formato legible y localizado.
 */
const dateToLocaleString = date => {
  if (!date) {
    throw new Error('"date" es requerido para formatear la fecha a local.');
  }
  const dateTimeFormatter = new Intl.DateTimeFormat(LOCALES).format;
  return dateTimeFormatter(ISOStringToDate(date));
};

export default dateToLocaleString;
